import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='footerContainer'>
     <footer className='footer'>
       <p>Developed and Designed by: <span>Flavia Fogliato</span>     .     2023 </p>
     </footer>
    </div>
  )
}

export default Footer